var _rect;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStepNumber(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.768,
    y: 33.941,
    width: 45.5,
    height: 45.5,
    rx: 7.75,
    transform: "rotate(-45 1.768 33.941)",
    stroke: "#EB6E46",
    strokeWidth: 2.5
  })));
}

export default SvgStepNumber;